import { type CSSProperties, type MouseEvent, useCallback, useState } from 'react'

import { type CardRefType } from '@/defs/card'
import { cn } from '@/utils/commonUtil'
import { buildRec } from '@/utils/recUtil'

import { CardRec } from '../CardRec/CardRec'

import styles from './CardStack.module.scss'

type Props = {
  cards: CardRefType[]
  href?: string
}

export const CardStack = ({ cards, href }: Props) => {
  const [raised, setRaised] = useState<number>(cards.length - 1)

  const onClickFace = useCallback(
    (e: MouseEvent, index: number) => {
      const isTouch = e.nativeEvent instanceof PointerEvent && e.nativeEvent.pointerType === 'touch'
      if (index === raised || !isTouch) return
      e.preventDefault()
      setRaised(index)
    },
    [raised],
  )

  return (
    <div className={styles.container} style={{ '--total': cards.length } as CSSProperties}>
      {cards.map(({ cardId, name }, num) => (
        <div
          className={cn(styles.card, { raised: raised === num, styles })}
          key={num}
          onClickCapture={(e) => onClickFace(e, num)}
          style={{ '--num': num } as CSSProperties}
        >
          <CardRec controls='none' href={href} rec={buildRec({ cardId, name, onlyFront: true })} />
        </div>
      ))}
    </div>
  )
}
